import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const reftab = defineConnector({
  identifier: "reftab",
  name: "Reftab",
  tagLine: "Asset tracking and IT inventory",
  logo,
  protocol: "http",
  tags: ["it"],
  auth: customAuth("reftab"),
  steps: [
    {
      title: "Create Reftab API keys",
      items: [
        {
          kind: "markdown",
          content:
            "In Reftab, create API keys, then sign each request with your public key, your private key, and the `x-rt-date` header.",
        },
      ],
    },
    {
      title: "Enter your Reftab API keys",
      items: [
        {
          kind: "input",
          label: "Public key",
          required: true,
          target: { kind: "configuration", field: "publicKey" },
        },
        {
          kind: "input",
          label: "Private key",
          required: true,
          target: { kind: "secrets", field: "privateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.reftab.com/api/assets/1",
  },
  defaultUrlPattern: () => "https://www\\.reftab\\.com/api/.*",
});
